/**
 * Centralized color tokens
 * Re-exports values from gluestack-ui.config.ts (single source of truth)
 */

import { config } from '../../gluestack-ui.config';

const c = config.tokens.colors;

export const colors = {
  // Brand
  primary: c.primary,
  primary50: c.primary50,
  primary100: c.primary100,
  primary400: c.primary400,
  primary600: c.primary600,
  primary700: c.primary700,
  primarySoft: c.primarySoft,
  primarySoftDark: c.primarySoftDark,

  // Secondary
  secondary: c.secondary,
  secondarySoft: c.secondarySoft,
  secondarySoftDark: c.secondarySoftDark,

  // Backgrounds
  background: c.background,
  backgroundDark: c.backgroundDark,
  card: c.card,
  cardDark: c.cardDark,
  inputBg: c.inputBg,
  inputBgDark: c.inputBgDark,

  // Text
  text: c.text,
  textDark: c.textDark,
  textSecondary: c.textSecondary,
  textSecondaryDark: c.textSecondaryDark,
  inputPlaceholder: c.inputPlaceholder,
  inputPlaceholderDark: c.inputPlaceholderDark,

  // Borders
  border: c.border,
  borderDark: c.borderDark,

  // Feedback
  error: c.error,
  success: c.success,
  warning: c.warning,
  warningBg: c.warningBg,
  warningBgDark: c.warningBgDark,
  errorBg: c.errorBg,
  errorBgDark: c.errorBgDark,
  successBg: c.successBg,
  successBgDark: c.successBgDark,
  infoBg: c.infoBg,
  infoBgDark: c.infoBgDark,

  // Overlay
  overlay: c.overlay,
  overlayDark: c.overlayDark,

  // Chat bubbles
  userBubbleStart: c.userBubbleStart,
  userBubbleEnd: c.userBubbleEnd,

  // Accent
  accent: c.accent,
  accentSoft: c.accentSoft,
  accentSoftDark: c.accentSoftDark,

  // Listening/Recording
  listening: c.listening,
  recording: c.recording,
} as const;
